import { z } from "zod";
import { getProjectSchema } from "./get-project.schema";

export const getProjectContactSchema = z
	.object({
		contactId: z.uuid(),
	})
	.and(getProjectSchema);

export type GetProjectContactSchema = z.infer<typeof getProjectContactSchema>;
